module.exports = __webpack_public_path__ + "static/media/Yanmega_gaussian2.899d026d.png";